// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addWishList } from "@bg/App/Services/WishListService";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addWishListLines } from "@insite/client-framework/Services/WishListService";
import {
    AddLineToWishList,
    AddWishList,
    chain,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";

export const XngAddWishList: any = async (props: any) => {
    props.result = {};
    try {
        props.result.wishList =
            props.parameter.selectedWishList ??
            (await addWishList({ name: props.parameter.newListName, groups: props.parameter.groups }));
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

export const XngAddLineToWishList: any = async (props: any) => {
    if (!props.result.wishList) {
        return;
    }

    try {
        const lines = props.parameter.productInfos.map((productInfo: ProductInfo) => ({
            productId: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            properties: (productInfo as any).properties,
        }));
        await addWishListLines({ wishList: props.result.wishList, lines });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        if (error?.status === 404) {
            props.result.errorMessage = error.errorMessage;
            return;
        }
        throw error;
    }
};

replaceInChain(chain, AddWishList, XngAddWishList);
replaceInChain(chain, AddLineToWishList, XngAddLineToWishList);
